// ink-component
import React, { HTMLAttributes } from 'react';

import getGlobalProps from '../../../../helpers/constants/global-props';
import Shimmer from '../../../Shimmer/Shimmer';

const globalProps = getGlobalProps({});

/**
 * @purpose Provides user feedback to mitigate focus on the loading process within NewTable
 * @group NewTable
 * @categories table
 */

// eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
function NewTableShimmer(props: HTMLAttributes<HTMLDivElement>) {
  const shimmerProps = {
    ...props,
    ...globalProps,
    style: undefined,
    className: undefined,
  };

  return <Shimmer.Rectangle height="20px" {...shimmerProps} />;
}

NewTableShimmer.displayName = 'NewTable.Shimmer';

export default NewTableShimmer;
